<template>
    <v-card>
        <v-list rounded>
        <v-subheader>GUEST MENU</v-subheader>
        <v-list-item-group
            v-model="selectedItem"
            color="accent"
        >
            <v-list-item
            v-for="(item, i) in items"
            :key="i"
            >
            <v-list-item-icon>
                <span class="icon-badge">
                    <v-icon size="20" v-text="item.icon"></v-icon>
                </span>
            </v-list-item-icon>
            <v-list-item-content>
                <router-link :to="{name: item.routerName}" class="nav-link">
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                </router-link>
            </v-list-item-content>
            </v-list-item>
        </v-list-item-group>
        </v-list>
    </v-card>
</template>

<script>
  export default {
    name: 'GuestMenuCard',
    data: () => ({
        selectedItem: null,
        items: [
            { text: 'Register School', icon: 'mdi-account', routerName: 'Register' },
            { text: 'School Admin Login', icon: 'mdi-login-variant', routerName: 'Login' },
            { text: 'Recover Password', icon: 'mdi-lock', routerName: 'RecoverPassword' },
            { text: 'Teacher Access', icon: 'mdi-location-enter', routerName: 'MultiAccessLogin' },
            { text: 'Student Access', icon: 'mdi-location-enter', routerName: 'MultiAccessLogin' },
        ],
    }),
  }
</script>

<style scoped>
.v-card{
    background: transparent !important;
    box-shadow: none !important;
}
.v-subheader{
    color: rgba(255, 255, 255, 0.45) !important;
    letter-spacing: 1.5px;
    font-weight: 700;
}
.icon-badge{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.75);
}
.nav-link{
    text-decoration: none;
    color: rgba(255, 255, 255, 0.85) !important;
    display: block;
    width: 100%;
}
.router-link-active{
    color: #FB8C00 !important;
    font-weight: 700;
}
</style>
